import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=27e3e9d3&lang=less"
import "./index.vue?vue&type=style&index=1&id=27e3e9d3&lang=less&scoped=true"
script.__scopeId = "data-v-27e3e9d3"

export default script